import { initIcons } from "./icons";

import { initHomeHeroCarousel } from "./homeHero";
import { initTabs, initCollapses, initCarousels, initTooltips } from "flowbite";

import { ImageLightbox } from "./utils/lightbox.js";
import { navbar } from "./utils/navbar";
import { initCartUI } from "./cart/cart-ui";
import { NewsletterSignup } from "./newsletter";
import { CartService } from "./cart/cart";
import { initValidation } from "./validation";
import { initPrices } from "./utils/locale";
import { initAccountDeliveryForm } from "./account";

function initializeUI() {
    initTabs();
    initCollapses();
    initCarousels();
    initTooltips();
}

function handleImageLoad(img: HTMLImageElement) {
    img.classList.add("loaded");

    const wrapper = img.closest(".img-skeleton");
    if (wrapper) {
        wrapper.classList.remove("loading");
        wrapper.classList.add("loaded"); 
    }
}
function initImageSkeletons() {
    const wrappers = document.querySelectorAll<HTMLElement>(".img-skeleton");

    wrappers.forEach(wrapper => {
        const img = wrapper.querySelector<HTMLImageElement>("img");
        if (!img) return;

        // ALWAYS start clean
        wrapper.classList.remove("loading");

        if (img.complete && img.naturalWidth > 0) {
            img.classList.add("loaded");
            wrapper.classList.remove("loading"); // 🔥 THIS WAS MISSING
            return;
        }

        wrapper.classList.add("loading");

        img.addEventListener("load", () => handleImageLoad(img));

        setTimeout(() => {
            if (!img.classList.contains("loaded")) {
                handleImageLoad(img);
            }
        }, 2000);
    });
}

document.addEventListener("DOMContentLoaded", () => {
    initializeUI();
    initHomeHeroCarousel();
    navbar.init();
    initPrices();

    initValidation();
    initAccountDeliveryForm();
    initImageSkeletons();

    // Now async work can happen without breaking checkout
    const path = window.location.pathname;

    if (!path.startsWith("/checkout") && !path.startsWith("/admin")) {
        CartService.loadCount();
    }

    initIcons();
    initCartUI();
    new ImageLightbox(".previewable");
    new NewsletterSignup();

    window.initIcons = initIcons;
});
